import React, { useMemo, useState } from "react";
import { NotebookPen, Trash2, CheckCheck, FileDown, Loader2 } from "lucide-react";
import QuestionCard from "./QuestionCard";
import { COURSES, findQuestion } from "@/data";

export function mistakeEntries(mistakes, scope) {
  return Object.entries(mistakes)
    .map(([key, m]) => {
      const f = findQuestion(m.examId);
      if (!f) return null;
      const q = f.exam.questions[m.qi];
      if (!q) return null;
      return { key, ...m, q, exam: f.exam, course: f.course };
    })
    .filter(Boolean)
    .filter((m) => scope === "all" || m.course.key === scope)
    .sort((a, b) => b.ts - a.ts);
}

export default function MistakeBook({ course, mistakes, setMistakes, scope, setScope, onPdf, pdfBusy }) {
  const [retry, setRetry] = useState({});
  const list = useMemo(() => mistakeEntries(mistakes, scope), [mistakes, scope]);

  const remove = (key) => {
    const n = { ...mistakes };
    delete n[key];
    setMistakes(n);
    const r = { ...retry };
    delete r[key];
    setRetry(r);
  };
  const clearScope = () => {
    const n = { ...mistakes };
    list.forEach((m) => delete n[m.key]);
    setMistakes(n);
  };

  return (
    <div>
      <div className="section-head">
        <span className="eyebrow"><NotebookPen size={13} /> Hata Defterim</span>
        <h1 className="page-title">Hata Defterim</h1>
        <p className="page-sub">Sınavlarda yanlış yaptığın sorular burada otomatik toplanır. Tekrar çöz, doğru yaptığında defterden çıkar.</p>
      </div>

      <div className="mb-toolbar">
        <div className="chips">
          <button className={`chip ${scope === course.key ? "active" : ""}`} onClick={() => setScope(course.key)} data-testid="mb-scope-course">{course.code}</button>
          <button className={`chip ${scope === "all" ? "active" : ""}`} onClick={() => setScope("all")} data-testid="mb-scope-all">Tüm dersler</button>
        </div>
        <div className="fc-tools">
          <span className="muted" data-testid="mb-count">{list.length} soru</span>
          {list.length > 0 && (
            <>
              <button className="btn btn-ghost" onClick={onPdf} disabled={pdfBusy} data-testid="mb-pdf">{pdfBusy ? <Loader2 size={15} className="spin" /> : <FileDown size={15} />} PDF</button>
              <button className="btn btn-ghost danger" onClick={clearScope} data-testid="mb-clear"><Trash2 size={15} /> Temizle</button>
            </>
          )}
        </div>
      </div>

      {list.length === 0 ? (
        <div className="empty" data-testid="mb-empty">
          <CheckCheck size={30} />
          <p>Hata defterin boş. Deneme sınavlarında yanlış yaptığın sorular burada görünecek.</p>
        </div>
      ) : (
        <div className="q-list">
          {list.map((m) => {
            const r = retry[m.key];
            const retried = r !== undefined;
            return (
              <div key={m.key} className="mb-item" data-testid={`mb-item-${m.key}`}>
                <div className="mb-meta">
                  <span className="badge">{COURSES[m.course.key].code} · {m.exam.title} · Soru {m.qi + 1}</span>
                  <span className="muted">İlk cevabın: {"ABCDE"[m.chosen]}</span>
                </div>
                <QuestionCard
                  q={m.q}
                  number={m.qi + 1}
                  chosen={retried ? r : undefined}
                  onAnswer={(c) => setRetry({ ...retry, [m.key]: c })}
                  testPrefix={`mb-${m.key.replace(/[^a-z0-9]/gi, "")}`}
                />
                <div className="mb-actions">
                  {!retried && <button className="btn btn-ghost" onClick={() => setRetry({ ...retry, [m.key]: m.chosen })} data-testid={`mb-show-${m.key}`}>Çözümü göster</button>}
                  {retried && r !== m.q.a && <button className="btn btn-ghost" onClick={() => { const x = { ...retry }; delete x[m.key]; setRetry(x); }}>Tekrar dene</button>}
                  <button className={`btn ${retried && r === m.q.a ? "btn-know" : "btn-ghost"}`} onClick={() => remove(m.key)} data-testid={`mb-remove-${m.key}`}>
                    <CheckCheck size={15} /> {retried && r === m.q.a ? "Öğrendim, defterden çıkar" : "Defterden çıkar"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
